// Helpers
import { getFormatUTCDate } from "@/Common/helpers/Dates";
import { getCellClassNameFn, isFooterCell } from "@/Common/helpers/Tables";
import { errorLogger, getError } from "@/Common/helpers/logger";
// Components
import { TypographyCell } from "@/Layouts/components/Tables/DataSmartTable/additional/TypographyCell";
import { TypographyHeader } from "@/Layouts/components/Tables/DataSmartTable/additional/TypographyHeader";
// Types
import { CustomColDef } from "@/Washouts/types/commons";
import { Issue } from "@/Common/types/tables";
// Constants
import { ID_GRID_COLDEF } from "@/Washouts/constants";
import { HEADER_CLASS_NAME } from "@/Constants/tables";
import { DATE_FORMAT } from "@/Constants/date";

export function prepareColumnDefinitions(issuesReference = "", localIssues: Issue[] = []): CustomColDef[] {
	return [
		ID_GRID_COLDEF,
		{
			field: "date",
			headerName: "Date",
			width: 100,
			type: "date",
			headerClassName: HEADER_CLASS_NAME,
			renderHeader: (params) => <TypographyHeader params={params} />,
			cellClassName: getCellClassNameFn(localIssues, { noWrap: true }, {}, issuesReference),
			renderCell: (params) => {
				let contents = params.formattedValue ?? params.value;
				if (isFooterCell(params)) {
					contents = "Spiffs Total";
				}
				return (
					<TypographyCell params={params} hints={{ noWrap: true }}>
						{contents}
					</TypographyCell>
				);
			},
			valueFormatter: (value) => {
				try {
					return getFormatUTCDate(value, DATE_FORMAT.usDateDashShortYear);
				} catch (error) {
					errorLogger(getError(error));
				}
				return "Undefined";
			},
		},
		{
			field: "title",
			headerName: "Spiff Name",
			width: 130,
			headerClassName: HEADER_CLASS_NAME,
			renderHeader: (params) => <TypographyHeader params={params} />,
			cellClassName: getCellClassNameFn(localIssues, {}, {}, issuesReference),
			renderCell: (params) => <TypographyCell params={params} />,
		},
		{
			field: "type",
			headerName: "Spiff Type",
			width: 130,
			headerClassName: HEADER_CLASS_NAME,
			renderHeader: (params) => <TypographyHeader params={params} />,
			cellClassName: getCellClassNameFn(localIssues, {}, {}, issuesReference),
			renderCell: (params) => <TypographyCell params={params} />,
		},
		{
			field: "repairOrderNumbers",
			headerName: "Repair Orders #",
			width: 199,
			headerClassName: HEADER_CLASS_NAME,
			renderHeader: (params) => <TypographyHeader params={params} />,
			cellClassName: getCellClassNameFn(localIssues, {}, {}, issuesReference),
			renderCell: (params) => <TypographyCell params={params} />,
			valueFormatter: (value?: unknown) => {
				if (value instanceof Array) {
					return value.join(", ") || "";
				}
				return "";
			},
		},
		{
			field: "reward",
			headerName: "Amount",
			width: 100,
			type: "number",
			align: "right",
			headerClassName: HEADER_CLASS_NAME,
			renderHeader: (params) => <TypographyHeader params={params} />,
			cellClassName: getCellClassNameFn(localIssues, { isMoney: true }, {}, issuesReference),
			renderCell: (params) => <TypographyCell render="absolute" params={params} hints={{ isMoney: true }} />,
		},
	];
}
